import { render, staticRenderFns } from "./DeleteAccountView.vue?vue&type=template&id=17810122&scoped=true"
import script from "./DeleteAccountView.vue?vue&type=script&lang=js"
export * from "./DeleteAccountView.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccountView.vue?vue&type=style&index=0&id=17810122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17810122",
  null
  
)

export default component.exports